module.exports = __webpack_public_path__ + "static/media/35.3680ae63.jpg";